import BlockAccess from './BlockAccess';

export default BlockAccess;
